import { Injectable } from '@angular/core';
import { TipoPadron } from '@shared/enums/tiposPadron';
import { CargaPadron } from '@shared/models/padrones/CargaPadron';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from '@environments';
import { of, Observable } from 'rxjs';
import { UrlApi } from '@shared/enums/urlApi';
import { BlobUploadCommonResponse } from '@azure/storage-blob';
import { ErrorModel } from '@shared/models/ErrorModel';
import { Sas } from '@shared/models/padrones/Sas';
import { tap } from 'rxjs/operators';
import { AzureBlobUploadService } from '@shared/azure-blob-upload.service';
import { Guid } from "guid-typescript";
import { Padron } from "@shared/models/facturacion/Padron";

@Injectable({ providedIn: 'root' })
export class PadronesService {

  private sas: Sas;

  facturacionBaseUrl = environment.apiServer.facturacionBaseUrl;
  loteCargas: CargaPadron[] = [];

  constructor(private azureBlobUpload: AzureBlobUploadService, private http: HttpClient) { }

  cargarPadron(file: File, responsable: string, tipoPadron: TipoPadron) {
    const carga: CargaPadron = new CargaPadron(file.name, tipoPadron);
    this.loteCargas = this.loteCargas.filter(c => c.tipoPadron !== tipoPadron);
    this.loteCargas.push(carga);

    this.obtenerSas().subscribe((sas: Sas) => {
      const aborter = this.azureBlobUpload.uploadFileToBlobStorage(file, sas.containerUri, sas.sas,
        (pro) => {
          carga.progress = pro;
        },
        (val: BlobUploadCommonResponse) => {
          if (val) {
            const urlTipoPadron = tipoPadron;
            const url = `${this.facturacionBaseUrl}${UrlApi.padrones}/${urlTipoPadron}/encolar-padron/${encodeURIComponent(file.name)}?Responsable=${encodeURIComponent(responsable)}`;

            this.http.post<number>(url, null).subscribe(
              () => {
                carga.progress = 100;
                carga.finalizar(`El archivo se procesó correctamente. Tenga en cuenta que pueden pasar varios minutos hasta que se vea reflejado en el sistema.`);
              },
              (error: ErrorModel) => {
                carga.error = error.description;
              }
            );
          }
        });
      carga.setAborter(aborter);
    });
  }

  cargarPadronJujuy(
    filePrincipal: File,
    tipoPadron: TipoPadron,
    guidFile: Guid,
    responsable: string,
    onSuccess?: () => void  // Callback opcional
  ) {
    const carga: CargaPadron = new CargaPadron(filePrincipal.name, tipoPadron);
    this.loteCargas = this.loteCargas.filter(c => c.tipoPadron !== tipoPadron);
    this.loteCargas.push(carga);

    this.obtenerSas().subscribe((sas: Sas) => {
      const aborter = this.azureBlobUpload.uploadFileToBlobStorage(filePrincipal, sas.containerUri, sas.sas,
        (pro) => {
          carga.progress = (pro * 0.8);
        },
        (val: BlobUploadCommonResponse) => {
          if (val) {
            const idStr = (guidFile as any).value ?? String(guidFile);

            const url = `${this.facturacionBaseUrl}${UrlApi.padrones}/${tipoPadron}/importar-padron-sincrono/${filePrincipal.name}?Id=${encodeURIComponent(idStr)}&Responsable=${responsable}`;


            this.http.post<any>(url, null, {
              reportProgress: true,
              observe: 'events'
            }).subscribe(
              (event: HttpEvent<any>) => {
                if (event.type === HttpEventType.UploadProgress) {
                  const progresoEndpoint = Math.round((20 * event.loaded) / event.total);
                  carga.progress = 80 + progresoEndpoint;
                } else if (event.type === HttpEventType.Response) {
                  carga.progress = 100;
                  carga.finalizar('El archivo de Jujuy se procesó correctamente.');
                  // Llamar al callback si existe
                  if (onSuccess) {
                    onSuccess();
                  }
                }
              },
              (error: ErrorModel) => {
                carga.error = error.description || 'Error al cargar el archivo';
              }
            );
          }
        });
      carga.setAborter(aborter);
    });
  }

  ObtenerHistorialPadrones(page: number, pageSize: number) {
    return this.http.get<Padron[]>(this.facturacionBaseUrl + UrlApi.padrones + `/ObtenerHistorialPadrones?page=${page}&pageSize=${pageSize}`).toPromise();
  }

  cancelarCarga(carga: CargaPadron) {
    carga.cancelarCarga();
  }

  obtenerSas(): Observable<Sas> {
    /* verificar si está vencida antes de pedir uno nuevo */
    if (this.sas) {
      const decodedUri = decodeURIComponent(this.sas.sas);
      const fechaSas = new Date(decodedUri.substr(decodedUri.indexOf('&se=') + 4, 20));
      if (fechaSas > new Date())
        return of(this.sas);
    }
    const url = this.facturacionBaseUrl + UrlApi.configuracion + '/SAS/';
    return this.http.get<Sas>(url).pipe(tap((sas: Sas) => this.sas = sas));
  }
}
